import { h } from 'preact';
import { render } from 'preact';
import { ensureOverlayRoot } from './OverlayRoot.js';

let stack = [];

function Modal({ title, content, actions = [], onClose, className = '', presentation }) {
  return (
    <div class="uk-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div class={`uk-modal ${presentation === 'sheet' ? 'sheet' : ''} ${className || ''}`.trim()} role="dialog" aria-modal="true" aria-label={title}>
        <div class="uk-modal-header">
          <h3 class="uk-modal-title">{title}</h3>
          <button class="uk-modal-close" onClick={onClose}>×</button>
        </div>
        <div class="uk-modal-body">
          {typeof content === 'string' ? <div dangerouslySetInnerHTML={{ __html: content }} /> : content}
        </div>
        {actions?.length ? (
          <div class="uk-modal-footer">
            {actions.map((a) => {
              const cls = (a.class || a.className || '').trim();
              const classes = cls
                ? cls // respect provided classes (e.g., 'btn btn-primary')
                : 'btn btn-secondary btn-small';
              return (
                <button class={classes} onClick={() => a.action?.() || onClose()}>{a.text || a.label}</button>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export const ModalService = {
  open({ title, content, actions = [], className = '', presentation } = {}) {
    const root = ensureOverlayRoot();
    const host = document.createElement('div');
    root.appendChild(host);
    const close = () => {
      try { render(null, host); } catch (_) {}
      host.remove();
      stack = stack.filter((x) => x !== close);
      if (stack.length === 0) root.style.pointerEvents = 'none';
    };
    stack.push(close);
    root.style.pointerEvents = 'auto';
    render(<Modal title={title} content={content} actions={actions} onClose={close} className={className} presentation={presentation} />, host);
    return close;
  },
  closeTop() {
    const top = stack.pop();
    if (top) top();
  }
};

export default ModalService;
